import * as SubNav from 'components/sub-nav';
import { IntercomProductTourTargets } from 'constants/intercom';
import { TestIds } from 'constants/tests';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const EngageSubNavTabs = () => {
    const { accountId } = useCurrentAccount();

    return (
        <SubNav.Tabs>
            <SubNav.TabItem to={`/accounts/${accountId}/engage/email`}>Emails</SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/engage/sms`}
                data-testid={TestIds.Engage.Texts}
            >
                Texts
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/engage/letters`}
                data-testid={TestIds.Engage.Mailings}
            >
                Mailings
            </SubNav.TabItem>
            <SubNav.TabItem
                to={`/accounts/${accountId}/engage/settings`}
                data-intercom-target={IntercomProductTourTargets.EngageSettingsSubnavTab}
                data-testid={TestIds.Engage.Settings.EmailDomains}
            >
                Settings
            </SubNav.TabItem>
        </SubNav.Tabs>
    );
};

export { EngageSubNavTabs };
